module.exports = __webpack_public_path__ + "fonts/AznauriRoundBold-2.ed5f5e72.ttf";